import {
  FormEnumFieldWidget,
  FormFieldWidget,
  ModelFieldType,
  RuntimeEnumerationOption,
  SPI,
  ViewType,
  Widget,
  http
} from '@kunlun/dependencies';

import { ariesIssuingMethodEnumMap } from '../../../../constants';

type EnumerationValue = boolean | string;

@SPI.ClassFactory(
  FormFieldWidget.Token({
  viewType: ViewType.Form,
  ttype: ModelFieldType.Enum,
  model: [
  'deli.aries.seller.DeliAriesSellerPurchasingPlan',
  'deli.aries.merchant.DeliAriesBuyerPurchasingPlan'
  ],
  name: 'issuingMethod',
  multi: false
  })
  )
  
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.Enum,
    widget: 'ProxyDelivery',
    multi: false
  })
)
export class FormEnumProxyDeliveryFieldWidget extends FormEnumFieldWidget {
  public initialize(props) {
    super.initialize(props);
    // this.setComponent(ProxyDelivery);
    return this;
  }

  @Widget.Reactive()
  selectOptions: RuntimeEnumerationOption[] = [];

  @Widget.Reactive()
  protected get options(): RuntimeEnumerationOption[] {
    return this.selectOptions;
  }

  @Widget.Reactive()
  get disabled() {
    return this.formData.orderType === 'DROPSHIPPING' && this.formData.bizType === 'OFFLINE_DROPSHIPPING';
  }

  checkAndUpdateValue() {    
    if (this.formData.orderType === 'DROPSHIPPING' && this.formData.bizType === 'OFFLINE_DROPSHIPPING') {
      this.setValue('ONE');
    }
  }

  @Widget.Watch('formData.orderType')
  protected watchOrderType(value: string) {
    if (value) {
      this.getProxyDeliveryOptionsByOrderType(value);
      this.checkAndUpdateValue();
    } else {
      this.selectOptions = [];
    }
  }

  // 要货计划的字段：
  // 订单类型 ariesTradeOrderTypeEnum
  @Widget.Watch('formData.ariesTradeOrderTypeEnum')
  protected watchAriesTradeOrderTypeEnum(value: string) {
    if (value) {
      this.getProxyDeliveryOptionsByOrderType(value);
      this.checkAndUpdateValue();
    } else {
      this.selectOptions = [];
    }
  }

  @Widget.Watch('formData.bizType')
  protected watchBizType(value: string) {
    if (value) {
      this.checkAndUpdateValue();
    }
  }

  // 要货计划的字段：
  // 业务类型 ariesTradeOrderBizTypeEnum
  @Widget.Watch('formData.ariesTradeOrderBizTypeEnum')
  protected watchAriesTradeOrderBizTypeEnum(value: string) {
    if (value) {
      this.checkAndUpdateValue();
    }
  }

  async getProxyDeliveryOptionsByOrderType(orderType: string) {
    this.selectOptions = [];
    const res = await this.queryProxyDeliveryOptions();
    this.formData.deliveryMethods = res.deliveryMethods;
    this.selectOptions = (res.ariesIssuingMethodOptions as any).map((k) => ({ name: k, displayName: ariesIssuingMethodEnumMap[k], value: k }));
    if (this.selectOptions.length) {
      if (this.selectOptions.find((option) => option.value === this.value)) return;
      let defaultTarget =this.selectOptions[0].value;
      this.setValue(defaultTarget);
    } else {
      this.setValue(null);
    }
  }
  
  async queryProxyDeliveryOptions() {
    const gql = `
      query {
        sellerDistributionCreateOrderParamQuery {
          constructDeliveryInfo(data: { 
            orderType: ${this.formData.orderType || this.formData.ariesTradeOrderTypeEnum}
            buyerPartnerId: ${this.formData.buyerPartnerId}
            sellerPartnerId: ${(this.formData.seller as any)?.id ?? this.formData.sellerPartnerId}
            salesOfficeId: ${(this.formData.salesOffice as any)?.id ?? this.formData?.salesOfficeId}
          }) {
            ariesIssuingMethodOptions
            deliveryMethods
          }
        }
      }
    `;
    const res = await http.query(this.model.moduleName, gql);
    return res.data.sellerDistributionCreateOrderParamQuery.constructDeliveryInfo;
  }

  change(val: EnumerationValue | null | undefined): void {
    super.change(val);
    // 清空收货人信息
    Object.assign(this.formData.deliveryAddress as any, {
      contactMan: '',
      contactPhone: '',
      detailAddress: ''
    });
  }
}
